/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiDocument,
    InternalApiDocumentFromJSON,
    InternalApiDocumentToJSON,
    InternalApiUniversalDocumentsList,
    InternalApiUniversalDocumentsListFromJSON,
    InternalApiUniversalDocumentsListToJSON,
} from '../models';

export interface DeleteCaseDocumentRequest {
    handle: string;
    documentId: number;
}

export interface DownloadCaseDocumentRequest {
    handle: string;
    documentId: number;
}

export interface DownloadCaseDocumentResponse {
    headers: Headers;
    body: Blob;
}

export interface FindCaseDocumentsRequest {
    handle: string;
}

export interface UploadCaseDocumentRequest {
    handle: string;
    file: Blob;
}

/**
 * 
 */
export class CaseDocumentInternalApi extends runtime.BaseAPI {

    /**
     * Deletes a case document
     */
    async deleteCaseDocumentRaw(requestParameters: DeleteCaseDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling deleteCaseDocument.');
        }

        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling deleteCaseDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/documents/{documentId}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a case document
     */
    async deleteCaseDocument(requestParameters: DeleteCaseDocumentRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteCaseDocumentRaw(requestParameters, initOverrides);
    }

    /**
     * Downloads a case document
     */
    async downloadCaseDocumentRaw(requestParameters: DownloadCaseDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling downloadCaseDocument.');
        }

        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling downloadCaseDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/documents/{documentId}`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Downloads a case document
     */
    async downloadCaseDocument(requestParameters: DownloadCaseDocumentRequest, initOverrides?: RequestInit): Promise<DownloadCaseDocumentResponse> {
        const response = await this.downloadCaseDocumentRaw(requestParameters, initOverrides);
        return {
          headers: response.raw.headers,
          body: await response.value(),
        };
    }

    /**
     * Fetches all documents for a case
     */
    async findCaseDocumentsRaw(requestParameters: FindCaseDocumentsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiUniversalDocumentsList>>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling findCaseDocuments.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/documents`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiUniversalDocumentsListFromJSON));
    }

    /**
     * Fetches all documents for a case
     */
    async findCaseDocuments(requestParameters: FindCaseDocumentsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiUniversalDocumentsList>> {
        const response = await this.findCaseDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Uploads a document to a case
     */
    async uploadCaseDocumentRaw(requestParameters: UploadCaseDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiDocument>> {
        if (requestParameters.handle === null || requestParameters.handle === undefined) {
            throw new runtime.RequiredError('handle','Required parameter requestParameters.handle was null or undefined when calling uploadCaseDocument.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadCaseDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/v1/cases/{handle}/documents`.replace(`{${"handle"}}`, encodeURIComponent(String(requestParameters.handle))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiDocumentFromJSON(jsonValue));
    }

    /**
     * Uploads a document to a case
     */
    async uploadCaseDocument(requestParameters: UploadCaseDocumentRequest, initOverrides?: RequestInit): Promise<InternalApiDocument> {
        const response = await this.uploadCaseDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
